import TestimonialsContainer from './TestimonialsContainer';

export default TestimonialsContainer;
